import "../styles/skills.scss";

const Skills = () => {
  return (
    <div div className="skills">
      <div className="container">
        <h1>Technical Skills</h1>
        <li><b>Programming Languages:</b> C#, Java, TypeScript, JavaScript, Python</li>
        <li><b>Frontend:</b> C#, Java, TypeScript, JavaScript, Python</li>
        <li><b>Backend:</b> ASP.NET Core (via ORM Entity Framework), Python (Flask), REST APIs, Microservices</li>
        <li><b>Databases:</b> MySQL, SQL Server, SQLite</li>
        <li><b>Testing & CI/CD:</b> Jest, NUnit, GitHub Actions, Jenkins</li>
        <li><b>Collaboration & Workflow:</b> Git, Figma, Jira, Slack, Agile/Scrum, Copilot</li>
      </div>
    </div>
  );
};

export default Skills;